<template>
  <div>
    <div>
      <div class="todo-list">
      <div class="todo-heading">The Main Steps!</div>
        <tiny-todo-item
          v-for="item in items"
          :id="item.id"
          :label="item.label"
          :checked="item.checked"
          :action="item.action"
          :assignment="assignment"
          :key="item.id"
        ></tiny-todo-item>
      </div>
    </div>
  <div class="todo-list">
    <todo-item
      v-for="item in items"
      :id="item.id"
      :label="item.label"
      :checked="item.checked"
      :action="item.action"
      :report="item.report"
      :reportReasons="item.reportReasons"
      :message="item.message"
      :assignment="assignment"
      :key="item.id"
      v-on:toggle-checked="toggleChecked($event)"
    ></todo-item>
    <div class="clearfix"></div>
  </div>
</div>
</template>

<script>
import Bus from "@/modules/Bus";
import TodoItem from "./TodoItem";
import DownloadManuscript from "./Actions/DownloadManuscript";
import ViewOnAmazon from "./Actions/ViewOnAmazon";
import TurnInReview from "./Actions/TurnInReview";

import { mapState } from "vuex";
import TinyTodoList from './TinyTodoList.vue';
import TinyTodoItem from './TinyTodoItem.vue';

export default {
  name: "TodoList",
  components: { TodoItem, TinyTodoList, TinyTodoItem },
  props: ["assignment"],
  data: function() {
    return {
      items: [
      ]
    };
  },
  created() {

    this.items = [
        {
          id: 1,
          checked: this.assignment.todos ? this.assignment.todos[1] : false,
          label: "Access the book",
          message: `This is a <b>Standard</b> assignment.
            <br>Please <b>download the book from pubby below</b>. Keep in mind, some book files are large and may take several minutes to download.`,
          action: "download-manuscript",
          report: "report-an-issue",
          reportReasons: [
            {
              'reason': 'broken-link-download',
              'message': `The file is not downloading after waiting several minutes - I cannot download the book.`
            },
          ]
        },
        {
          id: 2,
          checked: this.assignment.todos ? this.assignment.todos[2] : false,
          label: "Read the book",
          message: "Enjoy reading this book! To keep your account in good standing with both Amazon and pubby, it’s important to write thoughtful, opinionated, and lengthy reviews. Remember, your honest opinion is welcome here! Take your time forming an opinion.",
          report: "report-an-issue",
          reportReasons: [
              {
                'reason': 'not-interested',
                'message': 'I am no longer interested in this assignment.'
              },
              {
                'reason': 'more-time',
                'message': 'I need more time on this assignment.'
              },
            ]
        },
        {
          id: 3,
          checked: this.assignment.todos ? this.assignment.todos[3] : false,
          label: "Post your review on Amazon",
          message: `Click the button below to post a review on Amazon. 
            <br>Remember, we do not allow AI-written, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews. 
            <br>Amazon will not post your review immediately - that’s ok! <b>Continue on to step 4.</b>`,
          action: "post-on-amazon",
          report: "report-an-issue",
          reportReasons: [
              {
                'reason': 'broken-link-review',
                'message': `The book’s link is broken - I cannot review the book.`
              },
              {
                'reason': 'more-time',
                'message': 'I need more time on this assignment.'
              },
              {
                'reason': 'not-interested',
                'message': 'I am no longer interested in this assignment.'
              },
              {
                'reason': 'cant-review',
                'message': 'Amazon will not let me write a review.'
              },
            ]
        },
        {
          id: 4,
          checked: this.assignment.todos ? this.assignment.todos[4] : false,
          label: "Turn in this assignment on Pubby",
          action: "turn-in-review",
          message: `Click the button below to turn in your assignment. Do this step immediately after submitting your review to Amazon. This is a required step in the review process. Our automated system will look for your review on Amazon for ${this.reviewSearchLimit} days after you turn in your assignment.`
        }
      ];

    if (this.assignment.is_kindle) {
      this.items[0].message = `This is a <b>Kindle Unlimited</b> assignment.
            <br>Please <b>use your Kindle Unlimited reading subscription to download the ebook directly from Amazon</b>.`
      this.items[0].action = "view-on-amazon"
      this.items[0].reportReasons= [
            {
              'reason': 'broken-link-ku',
              'message': `The book’s link is broken - I cannot download the book on Kindle Unlimited.`
            },
            {
              'reason': 'not-on-ku',
              'message': `The book is not available thru Kindle Unlimited.`
            },
            {
              'reason': 'no-ku-sub',
              'message': 'I do not have a Kindle Unlimited reading subscription.'
            }
          ]
    }


    if (this.assignment.is_verified) {
      this.items[0].message = `This is a <b>Verified Purchase</b> assignment.
            <br>${this.purchaseInstructions} 
            Please <a href="https://intercom.help/pubby/en/articles/9677614-tips-getting-your-review-stamped-as-a-verified-purchase-by-amazon" target="_blank">follow our tips here</a> for best practices for getting your review stamped by Amazon.`
      this.items[0].action = "view-on-amazon"
      this.items[0].reportReasons= [
            {
              'reason': 'broken-link-purchase',
              'message': `The book’s link is broken - I cannot purchase the book.`
            },
            {
              'reason': 'price-mismatch',
              'message': `The book’s price on Amazon does not match the assignment on pubby.`
            },
          ]
    }
  },
  computed: {
    ...mapState({
      reviewSearchLimit: "reviewSearchLimit",
    }),
    purchaseInstructions() {
      if (this.assignment.listing_price === 0) {
        return `Please use the <b>free promotion</b> in order to <b>purchase the ebook directly from Amazon</b>.
          <br>Please do not purchase the paperback version of the book, as you will not have enough time to complete the assignment due to shipping delays. `
      } else if (this.assignment.listing_price > 0) {
        return `Please <b>purchase the ebook directly from Amazon</b> for the price of <b>$` + (this.assignment.listing_price - .01) + `</b>.
          <br>Please do not purchase the paperback version of the book, as you will not have enough time to complete the assignment due to shipping delays. 
          <br>You earned 300 extra snaps per dollar of this assignment as a way to say thanks for purchasing! If your review is not stamped as a Verified Purchase by Amazon, 
          we will later remove these extra snaps. `
      }
      return ''
    }
  },
  methods: {
    toggleLinkSubmissionForm() {
      this.showReviewLinkSubmissionForm = !this.showReviewLinkSubmissionForm
    },
    toggleChecked($event) {
      // Toggle the selected checkbox, then if the box was checked also check any previous boxes
      const thisEventId = $event.id-1
      this.items[thisEventId].checked = $event.checked

      this.items.forEach((element, index) => {
        if (index < thisEventId && $event.checked) {
          element.checked = $event.checked
        }
      });
      
    },
  }
};
</script>

<style lang="scss" scoped>
.todo-list {
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  border-radius: 12px;
  margin-bottom: 30px;
  padding: 24px;
  font-family: $font-family;
}

.todo-heading {
  font-size: 13pt;
  font-weight: 600;
  margin-bottom: 1em;
  color: #7e57c2;
}

@media (max-width: 1024px) {
  .todo-list {
    padding: 20px 16px;
  }
}

.extra-instructions {
  color: #777;
  font-size: 13pt;
  padding: 0 34px;
}
.extra-instructions-item {
  padding: 6px 0;
}
</style>

